export var isArrayOfArrays = function isArrayOfArrays(arr) {
  return arr.every(function (v) {
    return Array.isArray(v);
  });
};